import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const McGillUniversity = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="McGill University"
      universityShortName="McGill"
      slug="mcgill-university"
      seoTitle="McGill University Study Rooms | Montreal Campus Study Guide"
      seoDescription="Complete guide to study rooms at McGill University. Find Redpath Library, study pods, and group study spaces. Plus free 24/7 online alternative."
      seoKeywords="mcgill study rooms, mcgill library, redpath library, mcgill university study spaces, montreal university library, osler library"
      canonicalUrl="/study-room/mcgill-university/"
      heroDescription="A comprehensive guide to study rooms and spaces at McGill University in Montreal, including library branches and individual study pods."
      libraryWebsiteUrl="https://www.mcgill.ca/library/"
      libraryWebsiteName="McGill Library"
      studySpaces={[
        {
          name: "Group Study Rooms (Various Branches)",
          features: "Bookable group study rooms across several library branches with tables and whiteboards.",
          feedback: "Students often complain that group rooms fill up weeks in advance and are sometimes used as chill-out spaces rather than for studying."
        },
        {
          name: "Individual Study Pods ('Phone Booths')",
          features: "Sound-isolated individual pods perfect for calls and focused work.",
          feedback: "Some students love them because they offer sound isolation; others find them cramped."
        },
        {
          name: "Redpath Library Silent Zone",
          features: "Quiet study area in the historic Redpath Library building.",
          feedback: "Popular for focused individual study; can be busy during exam periods."
        },
        {
          name: "Osler Library Heritage Reading Room",
          features: "Beautiful heritage reading room with historic atmosphere.",
          feedback: "Praised for its ambiance; limited seating available."
        },
        {
          name: "McLennan Terrace",
          features: "Terrace area with views over Mount Royal and natural light.",
          feedback: "Great for studying when weather permits; limited indoor options nearby."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            For quiet study, explore the <strong>Redpath Library's silent zone</strong> or the <strong>Osler Library's heritage reading room</strong>. Book a pod if you need to focus on a call; they're small but private.
          </p>
          <p className="mb-4">
            If you crave natural light, the <strong>McLennan terrace</strong> offers views over Mount Royal. Early booking is essential—slots vanish quickly.
          </p>
          <p>
            Students must plan bookings far ahead as academically motivated students compete for limited spaces that are sometimes misused as lounging areas.
          </p>
        </>
      }
      summaryTips={[
        "Book weeks in advance: McGill study rooms fill up quickly, especially during midterms and finals.",
        "Try the study pods: Individual 'phone booth' pods offer sound isolation for calls and focused work.",
        "Explore Osler Library: The heritage reading room provides a unique, historic study atmosphere.",
        "Use McLennan terrace: When weather permits, enjoy views of Mount Royal while studying.",
        "Use CSW when rooms are booked: Virtual study rooms offer unlimited access when physical spaces are full."
      ]}
    />
  );
};

export default McGillUniversity;
